export const auditValue = (value) => {
  if (value === null || value === undefined || value === "None" || value === "null" || value === "") return "Empty";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

export const dailyAuditChanges = (record) => Object.entries(record.changes || {}).map(([field, values]) => {
  const pair = Array.isArray(values) && values.length === 2;
  return {
    field,
    oldValue: Number(record.action) === 0 ? "Not applicable (new record)" : pair ? auditValue(values[0]) : "Not recorded",
    newValue: auditValue(pair ? values[1] : values),
  };
});

export const dailyAuditColumns = [
  { title: "Field Name", dataIndex: "field", key: "field" },
  { title: "Old Value", dataIndex: "oldValue", key: "oldValue" },
  { title: "Updated Value", dataIndex: "newValue", key: "newValue" },
];
